import { render } from "./alertComponent.vue?vue&type=template&id=45d16bd5"
import script from "./alertComponent.vue?vue&type=script&lang=js"
export * from "./alertComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__